import React from 'react';
import type { SpaceProps } from 'styled-system';

import SeparatorWithText from 'common/components/SeparatorWithText';
import { BodyRegularBR2 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';

const Separator = (spaceProps: SpaceProps) => {
  const { t } = useLocalization();

  return (
    <SeparatorWithText mt="sp_0" mb="sp_0" {...spaceProps}>
      <BodyRegularBR2>{t('h24_or')}</BodyRegularBR2>
    </SeparatorWithText>
  );
};

export default Separator;
